// @ts-nocheck
// PurchaseOrders types for Redux actions

const SALES_ORDERS_TABLE_STATE_SET = 'SALES_ORDERS/TABLE_STATE_SET';
const SALES_ORDERS_TABLE_STATE_RESET = 'SALES_ORDERS/TABLE_STATE_RESET';

export default {
  SALES_ORDERS_TABLE_STATE_SET,
  SALES_ORDERS_TABLE_STATE_RESET,
};